export * from "./text";
export * from "./text.props";
